module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Ga-Ha-Ic-Jb.f9789f78.png";